import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Sidebar } from "@/components/Sidebar";

export function DashboardLayout() {
	const [sidebarOpen, setSidebarOpen] = useState(false);

	return (
		<div className="min-h-screen bg-background">
			{/* Mobile sidebar overlay */}
			{sidebarOpen && (
				<div
					className="fixed inset-0 bg-black/20 z-20 lg:hidden"
					onClick={() => setSidebarOpen(false)}
				/>
			)}

			{/* Sidebar */}
			<div
				className={`
        fixed inset-y-0 left-0 z-30 w-64 transform transition-transform duration-300 ease-in-out lg:translate-x-0
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
      `}
			>
				<Sidebar onClose={() => setSidebarOpen(false)} />
			</div>

			{/* Main content */}
			<div className="lg:pl-64">
				{/* Header */}
				<Header onMenuClick={() => setSidebarOpen(true)} />

				{/* Page content */}
				<main className="p-4 lg:p-6 lg:p-8">
					<Outlet />
				</main>
			</div>
		</div>
	);
}
